// extracted by mini-css-extract-plugin
export default {"lined":"Lined_lined__OvrSx"};